import { Box, Button, Flex, Heading, SimpleGrid } from '@chakra-ui/react';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ChakraFeatherIcon } from 'src/components/ChakraFeatherIcon';
import { PostsViraisFilters } from '../../types';
import { Club } from '@/model';
import TeamFilterSelect from '@/components/TeamFilterSelect';

export interface PostsViraisFilterBoxProps {
  clubs: Club[];
  filtersForm: UseFormReturn<PostsViraisFilters>;
  forceRefetch: () => void;
}

export const PostsViraisFilterBox = ({ clubs, filtersForm }: PostsViraisFilterBoxProps) => {
  const { t } = useTranslation();
  const { reset } = filtersForm;

  return (
    <Box>
      <Flex align='center' gap='pico' mb='deka'>
        <ChakraFeatherIcon color='text.main' name='filter' />
        <Heading variant='sectionTitle'>
          {t('pages.application_social_media.social_media_post_viral.filter_box.filter_box_title')}
        </Heading>
      </Flex>

      <Flex direction={{ base: 'row' }} gap='small' rowGap='micro'>
        <SimpleGrid
          gap='deka'
          alignItems='flex-end'
          columns={{ base: 1, sm: 2, md: 4, lg: 5, xl: 6 }}
          rowGap='xxsmall'
          flexGrow={1}
        >
          <TeamFilterSelect showFlag name='team_uuid' control={filtersForm.control} clubs={clubs} width='100%' />
        </SimpleGrid>

        <Button alignSelf={{ lg: 'end' }} colorScheme='text' variant='outline' mt='10px' onClick={() => reset()}>
          {t('pages.application_social_media.social_media_post_viral.filter_box.filter_box_clear')}
        </Button>
      </Flex>
    </Box>
  );
};
